module.exports = __webpack_public_path__ + "static/assets/3d11b7b0c025692d51cf6bde94dca19a.svg";